var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805H5.99609C5.46566 1.99805 4.95695 2.20876 4.58188 2.58383C4.20681 2.95891 3.99609 3.46761 3.99609 3.99805V19.998C3.99609 20.5285 4.20681 21.0372 4.58188 21.4123C4.95695 21.7873 5.46566 21.998 5.99609 21.998H17.9961C18.5265 21.998 19.0352 21.7873 19.4103 21.4123C19.7854 21.0372 19.9961 20.5285 19.9961 19.998V8.99805L12.9961 1.99805Z",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805V8.99805H19.9961",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#7755FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.564 22V16.584H5.588V15.52H8.972V16.584H8.004V22H6.564ZM9.5985 22L10.8545 18.512L9.6545 15.52H11.0065L11.7185 17.272L12.2945 15.52H13.4865L12.3505 18.888L13.6145 22H12.2705L11.4785 20.064L10.7825 22H9.5985ZM15.2037 22V16.584H14.2277V15.52H17.6117V16.584H16.6437V22H15.2037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.9a74bdd74613425c1f037400660a008f.svg";
export { ForwardRef as ReactComponent };